import type { CollectionFollowUpInput, CollectionFollowUpView, FollowUpListQuery, Page } from '@chukua/common';
import { toListParams } from '../../../../shared/policies/list-params';
import { api } from '../../../../shared/shared.api';

export type { CollectionFollowUpView };

export function listFollowUps(customerId: string, query: FollowUpListQuery): Promise<Page<CollectionFollowUpView>> {
  return api<Page<CollectionFollowUpView>>(`/customers/${customerId}/follow-ups?${toListParams(query)}`);
}

export function recordFollowUp(customerId: string, input: CollectionFollowUpInput): Promise<CollectionFollowUpView> {
  return api<CollectionFollowUpView>(`/customers/${customerId}/follow-ups`, { method: 'POST', body: JSON.stringify(input) });
}
